import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCustomerInfo } from '../ShoppingCartSliceV2';
import { isEmpty } from 'lodash';

// `currentCustomer` in localStorage is "the customer the agent is currently
// typing for a NEW order" — it must never be hydrated onto a page that's
// showing an already-placed order's real customer (skip=true there).
const useInitializeCurrentCustomer = (skip: boolean = false) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (skip) return;

    const customerInfo = JSON.parse(
      localStorage.getItem('currentCustomer') ?? '{}'
    );

    if (isEmpty(customerInfo)) return;

    dispatch(setCustomerInfo(customerInfo));
  }, [skip]);
};

export default useInitializeCurrentCustomer;
